export default __webpack_public_path__ + "static/favicon-ccf9172c2f73d31aea2887bf9c215c06.png";